<template>
  <div class="charge">
    <div class="toolBar">
      <p>
        <label>患者姓名：</label>
        <Input v-model="name" placeholder="患者姓名" />
      </p>
      <p>
        <label>医生：</label>
        <Input v-model="doctor" placeholder="医生"/>
      </p>
      <p>
        <label>自定义日期：</label>
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" placeholder="开始日期" v-model="startDate" @on-change="startTime"></DatePicker>
         —
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" placeholder="结束日期" v-model="endDate" @on-change="endTime"></DatePicker>
      </p>
      <p>
        <Button type="primary" @click="search">查询</Button>
      </p>
    </div>
    <div class="mainBox">
       <Table :height="tableHeight" ref="table" :columns="columns1" :data="data1" ></Table>
       <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize" />
       </div>
    </div>
    <Modal 
        width="60%"
        :name="modelName"
        v-model="modal2"
        :title="modelTitle"
        :scrollable="true"
        @on-visible-change="change"
        footer-hide >
        <div slot="header"><span>{{modelTitle}}</span></div>
        <div slot="close">
          <i class="iconfont icon-guanbi"></i>
        </div>
        <div class="accountBox">
          <apply-list :info="myInfo"></apply-list>
        </div>

    </Modal>
    <!-- 支付成功 -->
     <Modal 
        width="60%"
        :name="modelName"
        v-model="modalSuccess"
        :title="modelTitle"
        :scrollable="true"
        @on-visible-change="change"
        footer-hide>
        <div slot="header"><span>{{modelTitle}}</span></div>
        <div slot="close">
          <i class="iconfont icon-guanbi"></i>
        </div>
        <div class="accountBox">
          <apply-success :info="myInfo" v-on:modalOk="showModalOk"></apply-success>
        </div>
    </Modal>
    <!-- 支付失败 -->
    <Modal 
        width="60%"
        :name="modelName"
        v-model="modalError"
        :title="modelTitle"
        :scrollable="true"
        @on-visible-change="change"
        footer-hide>
        <div slot="header"><span>{{modelTitle}}</span></div>
        <div slot="close">
          <i class="iconfont icon-guanbi"></i>
        </div>
        <div class="accountBox">
          <apply-error :info="myInfo" v-on:modalShow="showModal"></apply-error>
        </div>
    </Modal>
    <Modal 
      width="60%"
      :name="modelName"
      v-model="modal1"
      :title="modelTitle"
      :scrollable="true"
      :footer-hide="true"
      @on-visible-change="change">
      <div slot="header">
        <span>{{modelTitle}}</span>
      </div>
      <div slot="close">
        <i class="iconfont icon-guanbi"></i>
      </div>
      <div class="accountBox">
        <div>
          <ul v-for="(pay,index) in payList" :key="index">
            <li>
              <span>患者名称：</span>
              <span>{{pay.patientName}}</span>
            </li>
            <li>
              <span>医生名称：</span>
              <span>{{pay.doctorName}}</span>
            </li>
            <li>
              <span>检验条码：</span>
              <span v-for="(code,sIndex) in pay.specimenBarCode" :key="sIndex">{{code}}</span>
            </li>
            <li>
              <span>项目名称：</span>
              <span v-for="(project,pIndex) in pay.names" :key="pIndex">{{project+','}}</span>
            </li>
            <li>
              <span>状态：</span>
              <span>{{pay.orderState+''|formatState}}</span>
            </li>
            <!-- <li>
              <span>支付时间</span>
              <span>{{pay.payTime}}</span>
            </li> -->
            <li>
              <span>检验金额：</span>
              <span>{{pay.amount}}</span>
            </li>
            <li><Button size="small" @click="toOrderDetail(pay.orderId)">详情</Button></li>
          </ul>
        </div>
      </div>
    </Modal>
    <Modal 
        class="infoModal"
        :name="modelName"
        v-model="modalCancel"
        :title="modelTitle"
        @on-ok="okChargeBtn"
        @on-cancel="cancelChargeBtn"
        ok-text="是" cancel-text="否">
        <p><Icon :custom="modeIcon" :color="iconColor"></Icon> {{modelContent}}</p>

    </Modal>
  </div>
</template>

<script>
import ApplyList from "@/components/ApplyList.vue";
import ApplySuccess from "@/components/ApplySuccess.vue";
import ApplyError from "@/components/ApplyError.vue";
import {
  inPayList,inWeChatPay,
  isPaySuccess,orderByPayId,
  delPayIn
} from '../../../api/outside';
import { tips,replaceT,payType,formatState,tradeState,payState2 } from "../../../tools";
export default {
  name: 'HaveCharge',
  inject:['reload'],
  data () {
    return {
      tableHeight:632,
      modelName:'',
      modal1:false,
      modal2:false,
      modal3:false,
      modalSuccess:false,
      modalError:false,
      modalCancel:false,
      modelTitle:'',
      modeIcon:'',
      iconColor:'',
      modelContent:'',
      cancelId:0,
      myInfo:[],
      options3:{
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
      isShow:true,//收费还是详情
      total:0,
      pageCurrent:1,
      pageSize: 10,
      name:'',//患者姓名/手机号
      doctor:'',//医生
      startDate:'',//开始日期
      endDate:'',//结束日期
      columns1:[
        {
          title: '选择',
          align: 'center',
          type: 'selection',
          width:60
        },
        {
          title: '支付用户名称',
          key: 'payUserName',
          align:'center'
        },
        {
            title: '支付类型',
            key: 'payType',
            align:'center',
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: payType(params.row.payType) 
              },
            })
          }
        },
        {
            title: '订单数量',
            key: 'orderTotal',
            align:'center'
        },
        {
          title: '状态',
          key: 'status',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: payState2(''+params.row.status)
              },
            })
          }
        },
        {
            title: '交易类型',
            key: 'tradeType',
            align:'center',
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: tradeState(params.row.tradeType) 
              },
            })
          }
        },
        {
            title: '检验金额(元)',
            key: 'amount',
            align:'center'
        },
        {
            title: '应收金额(元)',
            key: 'settleAmount',
            align:'center'
        },
        {
          width:236,
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-jiesuan'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal2 = true;
                      this.modelName = 'inPay';
                      this.modelTitle = '继续支付';
                      this.iconColor='#FE6E6E';
                      let id = params.row.id;
                      this.duration = 0;
                      this.toPay(id);
                    },
                  }
                }, '支付'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-xiangqing'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal1 = true;
                      this.modelName = 'payList';
                      this.modelTitle = '支付列表';
                      this.iconColor='#FE6E6E';
                      let id = params.row.id;
                      // this.toPay(id);
                      this.getOrderByPayId(id);
                    },
                  }
                }, '详情'),
                
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-guanbi1'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#c9c9c9',
                    color:'#575959'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modalCancel = true;
                      this.modelName = 'delPay';
                      this.modelTitle = '系统提示';
                      this.iconColor='#FE6E6E';
                      this.modelContent = '是否取消结算?';
                      this.modeIcon = ' iconfont icon-Group-';
                      this.cancelId = params.row.id;
                    },
                  }
                }, '取消'),
            ]);
          }
        }
      ],
      data1:[],
      orderIds:[],//项目id集合
      timer: null,
      payId:0,//支付id
      payList:[],//支付列表
      duration:0,//计时长度
    }
  },
  components: { ApplyList,ApplySuccess,ApplyError},
  filters:{
      formatState:function (state) {
          return formatState(state);
      }
    },
  created:function(){
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    this.clearTimer()
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    window.addEventListener('resize', this.getTableHeight);
    this.getTableHeight();
    this.loadList();
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    this.clearTimer()
  },
  methods:{
    getTableHeight(){
      // 设置表格高度 
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop-90; 
    },
    loadList(){
      this.search();
    },
    //新建定时器
    setTimer() {
      if(this.timer == null) {
        this.timer = setInterval( () => {
          console.log('开始定时...每过一秒执行一次')
          if(this.payId>0){
            this.isSuccess(this.payId);
            this.duration++;
            console.log(this.duration);
          }
        }, 1000)
      }
    },
    //清除计时器
    clearTimer(){
      clearInterval(this.timer);
      this.timer = null
    },
    //搜索
    search(){
      let _this = this;
      let params = {
        current: _this.pageCurrent,
        endTimes: _this.endDate,
        name: _this.doctor,
        nameAndPhone: _this.name,
        size: _this.pageSize,
        starTimes: _this.startDate,
        orderState:0
      };
      inPayList(
        params
      ).then(res => {
        console.log(res)
        let data = res.records;
        _this.total = res.total;
        _this.data1 = data;
      });
    },
    //接收支付失败页面的值
    showModal(data){
      console.log(data);
      this.modal2 = true;
      this.modalError = data;
    },
    //接收支付成功页面的值
    showModalOk(data){
      console.log(data);
      this.modalSuccess = data;
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
    //开始日期格式化
    startTime(e){
      this.startDate = e;
    },
    endTime(e){
      this.endDate = e;
    },
    //去支付
    toPay(orderId){
      inWeChatPay({
        id:orderId
      }).then(res=>{
        console.log(res);
        this.myInfo = res;
        this.payId = res.payId;
        this.modal2 = true;
        this.setTimer();
      });
    },
    //是否支付成功
    isSuccess(payId){
      isPaySuccess({
        id:payId
      }).then(res=>{
        // console.log(res);
        if(res){
          this.clearTimer();
          this.modal2 = false;
          this.modalSuccess = true;
        }else if(this.duration==60){
          this.clearTimer();
          this.modal2 = false;
          this.modalError = true;
        }else{
          console.log(111111);
        }
      })
    },
    //查询支付列表
    getOrderByPayId(payId){
      orderByPayId({
         id:payId
      }).then(res=>{
        console.log(res);
        this.payList = res;
      });
    },
    //支付中取消
    delPayIn(id){
      delPayIn({
         id:id
      }).then(res=>{
        console.log(res);
        tips(this,res,'success');
        this.loadList();
      });
    },
    //取消支付确定按钮
    okChargeBtn(){
      if(this.modelName=='delPay'){
        this.delPayIn(this.cancelId);
      }
    },
    //取消支付取消按钮
    cancelChargeBtn(){
      this.modalCancel = false;
    },
    toOrderDetail(id){
      // this.$emit('detail',id)
      this.$router.push(`/reportdetail/${id}`);
    },
    change(isShow){
      console.log(isShow);
      if(!isShow){
        this.clearTimer();
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.charge{

}
.charge .toolBar{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap ;
  padding: 10px 0;
}

.charge .toolBar>p>label{
  display: inline-block;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ivu-input-wrapper{
  width: 120px;
}
.ivu-select{
  width: 120px;
  /* width: 100%; */
}
.ivu-date-picker{
  width: 120px;
}

/* 详情弹框 */
.accountBox{
  width: 100%;
}
.accountBox /deep/ .ivu-modal{
  height: 600px;
  overflow: hidden;
}
.accountBox /deep/ .ivu-modal-content{
  height: 100%;
  overflow: hidden;
}
.accountBox>div>ul{
  display: flex;
  flex-flow: wrap row;
  padding: 10px 0;
  border-bottom: 1px solid #c9c9c9;
}
.accountBox>div>ul>li{
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}
.accountBox>div>ul>li>span:not(:first-child){
  padding-right: 10px;
}
.accountBox>div>ul>li>span:last-child{
  border-right: 1px solid #c9c9c9;
}
.ivu-modal-body{
  font-size: 14px;
  overflow: scroll;
  height: 300px;
}
.infoModal /deep/ .ivu-modal-content {
    height: auto;
    min-height: 0;
}
.basiInfo{
  display: flex;
  flex-flow: wrap row;
  justify-content: flex-start;
  padding: 8px 10px 8px;
  border-bottom: 1px solid #c9c9c9;
}
.basiInfo>p{
  margin-right: 30px;
  line-height: 32px;
}
.basiInfo>p>span:nth-child(2){
  padding-right: 30px;
  border-right: 1px solid #c9c9c9;
}
.basiInfo .keyName{
  color: #2778e2;
}
.projectBox{
  width: 100%;
}
.projectBox>p{
  padding: 10px 0;
  color:#030303;
  font-size: 14px;
  margin-left: 10px;
}
.projectBox>ul{
  width: 100%;
  border: 1px solid #c9c9c9;
}
.projectBox>ul>li{
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c9c9c9;
}
.projectBox>ul>li:last-child{
  border: none;
}
.projectBox>ul>li>span{
  text-align: center;
  width: 50%;
}
.projectBox>ul>li:first-child{
  height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #c9c9c9;
}
.projectBox>ul>li:first-child>span{
  color: #030303;
}
.payBox{
  width: 100%;
  margin-top: 15px;
}
.payBox>ul{
  width: 100%;
}
.payBox>ul>li{
  display: flex;
  justify-content: flex-start;
  height: 40px;
  line-height: 40px;
  margin-top: 15px;
}
.payBox>ul>li:first-child{
  height: auto;
}
.payBox>ul>li:first-child>p{
  width: 70%;
}
.payBox>ul>li:first-child>p>.ivu-input-wrapper{
  width: 100%;
}
.payBox>ul>li>label{
  width: 100px;
  text-align: right;
}
.payBox>ul>li:last-child>p>span{
  color: #ff4568;
  font-size: 20px;
}
.icon-zhanghuyue{
  color: #fd605f;
}
.icon-yibao{
  color: #06a0a2;
}
.icon-weixinzhifu{
  color: #00ab45;
}
.icon-zhifubao{
  color: #289bd6;
}
.icon-yinhangqia{
  color: #ff9d2d;
}
.ivu-modal-wrap>.ivu-modal>.ivu-modal-content>a.ivu-modal-close {
    z-index: 1;
    font-size: 12px;
    position: absolute;
    right: 12px;
    top: 12px;
    overflow: hidden;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/outsidesettle/inpay/InPay.vue